import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';

import { SPACE } from '../../Theme';
import fillArray from '../../../Util/fillArray';
import { Text } from '../../Base';
import { Table } from '../TableComponents';
import TableBodySection from './TableBodySection';
import TableHeaderSection from './TableHeaderSection';
import TableFooterSection from './TableFooterSection';

const ScoreRangeTable = ({
  columns,
  studentCountRow,
  percentageRow,
  score,
  examTitle,
  title,
  themeColor,
  scoreVariant,
}) => {
  const columnCount = columns.length;
  const formattedPercentageRow = fillArray(percentageRow, columnCount);
  const formattedRow = fillArray(studentCountRow, columnCount);

  return (
    <Box>
      <Text.Subtitle mb={SPACE.medium}>{title}</Text.Subtitle>
      <Box style={{ overflowX: 'auto' }}>
        <Table minWidth={'700px'} padding={'checkbox'} border>
          <TableHeaderSection columns={columns} score={score} color={themeColor} />
          <TableBodySection
            row={formattedRow}
            examTitle={examTitle}
            percentageRow={formattedPercentageRow}
          />
          <TableFooterSection
            columns={columns}
            score={score}
            color={themeColor}
            scoreVariant={scoreVariant}
          />
        </Table>
      </Box>
    </Box>
  );
};

ScoreRangeTable.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.array,
  studentCountRow: PropTypes.array,
  percentageRow: PropTypes.array,
  score: PropTypes.object,
  examTitle: PropTypes.string,
  themeColor: PropTypes.string,
};

ScoreRangeTable.defaultProps = {
  columns: [],
  studentCountRow: [],
  percentageRow: [],
  score: {},
};

export default ScoreRangeTable;
